import React, { Component } from 'react';
import { DHeader } from '../../../public/mobile/components/index'
import { hrRouter, compatibleNavImg, systemLang } from '../../../public/mobile/utils/index.js'
import NativeObj from '../../../public/mobile/utils/jsbridge/index.js'
import {getUrlParam, proFetchNew} from '../function';
import './index.less'
import ajaxhr from '../../../public/mobile/utils/ajax'
const appcode = '60652010'
import thirdLog from '../../../login/third-log-method/index';
import {Toast} from "antd-mobile";
import {editNav, errHandle} from "../../../attend-mobile/utils";
import { Modal} from 'antd-mobile';
import {Spin} from 'antd'
import 'antd/lib/spin/style/index.css'
import 'antd/dist/antd.css';

import {getMultiLang} from "../../../public/mobile/utils/getMultiLang";
import {isAuthExpiredResponse} from '../../../public/mobile/utils/authExpired';
import businessLogo from '../../../attend-mobile/images/leaveoffQuery.png'
import clockIn from '../../../attend-mobile/images/clockIn.png'
import businesstrip from '../../../attend-mobile/images/businesstrip.png'

const RouterPageNameFallback = {
  simpchn: {
    quitapply: '个人信息',
    leave: '请假申请',
    cancelLeave: '销假申请',
    approval: '审批中心',
    'my-salary': '薪资单',
    'my-tax': '税表',
  },
  tradchn: {
    quitapply: '個人信息',
    leave: '請假申請',
    cancelLeave: '銷假申請',
    approval: '審批中心',
    'my-salary': '薪資單',
    'my-tax': '稅表',
  },
  english: {
    quitapply: 'My Info',
    leave: 'Leave Application',
    cancelLeave: 'Leave Cancellation Application',
    approval: 'Approval Center',
    'my-salary': 'My Payslip',
    'my-tax': 'My Tax',
  },
}
const getRouterPageNames = () => RouterPageNameFallback[systemLang()] || RouterPageNameFallback.english
const getRouterPageName = (item, currentNames) => currentNames[item.code] || item.name

let RouterPageGroup = [
  {
    name: '假期額度查詢',
    nameCode: 'hrzzmb-000098',
    code: 'clockIn',
    color: 'blue',
    icon: 'hr-Scheduling',
    url: '/hrzz/attend-mobile/holidaySearch/main/indexMb.html',
    visable: true,
    auth: 'N'
  },
  {
    name: '休假情況查詢',
    nameCode: 'hrzzmb-000098',
    code: 'businesstrip',
    color: 'blue',
    icon: 'hr-employee-turnover1',
    url: '/hrzz/attend-mobile/leaveInquiry/main/indexMb.html',
    visable: true,
    auth: 'N'
  },
  {
    name: '我的申請',
    nameCode: 'hrzzmb-000098',
    code: 'businesstrip',
    color: 'blue',
    icon: 'hr-employee-turnover1',
    url: '/hrzz/attend-mobile/myApplication/main/indexMb.html',
    visable: true,
    auth: 'N'
  },
]
let RouterPage = [
    {
        name: '個人信息',
        code: 'quitapply',
        color: 'blue',
        icon: 'hr-personal-information',
        url: '/hrzz/psn-mobile/psn-info/main/index.html',
        visable: true,
    },
    // {
    //     name: '打卡&補卡',
    //     nameCode: 'hrzzmb-000098',
    //     code: 'clockIn',
    //     color: 'blue',
    //     icon: 'hr-fill-attendance',
    //     url: '/hrzz/attend-mobile/clockIn/main/index.html',
    //     visable:true,
    //     auth:'N'
    // },
    {
        name: '請假申請',
        code: 'leave',
        color: 'blue',
        icon: 'hr-leave2',
        url: '/hrzz/attend-mobile/leave/main/index.html',
        visable:true,
        auth:'N'
    },
    {
        name: '銷假申請',
        code: 'cancelLeave',
        color: 'blue',
        icon: 'hr-lishijilu',
        url: '/hrzz/attend-mobile/cancelLeave/main/index.html',
        visable:true,
        auth:'N'
    },
    // {
    //     name:'假期查詢',
    //     code: 'queryHoliday',
    //     color: 'blue',
    //     icon: 'hr-calendar',
    //     url: '/hrzz/attend-mobile/queryHoliday/main/index.html',
    //     visable:true,
    //     auth:'N'
    // },
    // {
    //     name: '加班申請',
    //     nameCode: 'hrzzmb-000098',
    //     code: 'overtime',
    //     color: 'blue',
    //     icon: 'hr-overtime',
    //     url: '/hrzz/attend-mobile/overtime/main/index.html',
    //     visable:true,
    //     auth:'N'
    // },
    // {
    //     name: '出差申請',
    //     nameCode: 'hrzzmb-000098',
    //     code: 'businesstrip',
    //     color: 'blue',
    //     icon: 'hr-business-travel',
    //     url: '/hrzz/attend-mobile/businesstrip/main/index.html',
    //     visable:true,
    //     auth:'N'
    // },
    // {
    //   name: '出差变更申请',
    //   code: 'leaveoffQuery',
    //   color: 'green',
    //   icon: 'hr-examination-and-approval',
    //   url: '/hrzz/attend-mobile/changeBusinessTrip/main/index.html',
    //   visable:true,
    //   auth:'N'
    // },
    // {
    //     name: '我的申請',
    //     nameCode: 'hrzzmb-000030',
    //     code: 'myApplication',
    //     color: 'blue',
    //     icon: 'hr-my-application',
    //     url: '/hrzz/attend-mobile/myApplication/main/index.html',
    //     visable:true,
    //     auth:'N'
    // },
    {
        name: '審批中心',
        code: 'approval',
        color: 'blue',
        icon: 'hr-HR-calendar',
        url: '/hrzz/approve-mobile/approval/main/index.html',
        visable:false,
        auth:'Y'
    },
    {
        name: '薪資單',
        code: 'my-salary',
        color: 'blue',
        icon: 'hr-check-salary',
        url: '/hrzz/mysalary-mobile-obu/my-salary/main/index.html',
        visable: true,
    },
    {
        name: '税表',
        code: 'my-tax',
        color: 'blue',
        icon: 'hr-check-salary',
        url: '/hrzz/mytax-mobile-obu/my-tax/main/index.html',
        visable: true,
    },
    //   {
    //     name: '我的考勤',
    //     // nameCode: 'hrzzmb-000030',
    //     code: 'myAttendanceinfo',
    //     color: 'blue',
    //     icon: 'hr-attendance-center',
    //     url: '/hrzz/attend-mobile/myAttendanceinfo/main/index.html',
    //     visable: true,
    // },
    // {
    //     name: '假勤代申请',
    //     nameCode: 'hrzzmb-000098',
    //     code: 'quithandover',
    //     color: 'green',
    //     icon: 'hr-my-application',
    //     url: '/hrzz/attend-mobile/agentapply/main/index.html',
    // },
    // {
    //     name: '开证明',
    //     nameCode: 'hrzzmb-000097',
    //     code: 'workhandover',
    //     color: 'orange',
    //     icon: 'hr-bumengongzuojiaojie',
    //     url: '/hrzz/certificate-mobile/certificate/main/index.html',
    // },
    // {
    //     name: '我的入职',
    //     nameCode: 'hrzzmb-000099',
    //     code: 'quitapproval',
    //     color: 'blue',
    //     icon: 'hr-gongzuojiaojieshenhe',
    //     url: '/hrzz/entry-mobile/myentry/main/index.html',
    // },
    // {
    //     name: '我的团队',
    //     nameCode: 'hrzzmb-000098',
    //     code: 'team',
    //     color: 'orange',
    //     icon: 'hr-lizhijiaojiedan',
    //     url: '/hrzz/myteam-mobile/myteam-index/main/index.html',
    // },
    // {
    //     name: '续签意见征询',
    //     nameCode: 'hrzzmb-000098',
    //     code: 'homepage',
    //     color: 'orange',
    //     icon: 'hr-lizhijiaojiedan',
    //     url: '/hrzz/mngopinion-mobile/opinion/main/index.html',
    // },
    // {
    //     name: '入职',
    //     nameCode: 'hrzzmb-000099',
    //     code: 'workreception',
    //     color: 'green',
    //     icon: 'hr-gongzuojiaojieshenhe',
    //     url: '/hrzz/entry-mobile/change_order/main/index.html',
    // }
]

let RouterPageBy418 = [
    {
        name: '審批中心',
        code: 'approval',
        color: 'blue',
        icon: 'hr-HR-calendar',
        url: '/hrzz/approve-mobile/approval/main/index.html',
        visable:false,
        auth:'Y'
    }
]
const url={
    loginInfo:'/ncchr/ncc/internal/mobile/loginInfo',
    PsninfoQueryAction:'/nccloud/hrzz/psninfo/PsninfoQueryAction.do',
  setlog: '/ncchr/ncc/internal/mobile/printlog',
  CheckPermissionByUser: '/ncchr/ncc/internal/mobile/checkPermissionByUser'
}
class Homepage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            json: {},
            image:"",
            imfodata:{},
            visable:false,    //是否显示遮罩层
          RouterPageMenu: [],
          showGroup: false,//3、权限管理：业务角色中含有“-DEPT-”的人员才有团队业务这2个节点的权限。
        }
        hrRouter.setRoot()
    }

    componentDidMount() {
        window.location.hash = 'c=' + appcode;
        this.urlParam = getUrlParam();
        let showNav=sessionStorage.getItem('showNav')
        if(!showNav){sessionStorage.setItem('showNav', true)}
        sessionStorage.removeItem('leaveType')
        console.log(this.urlParam)
        this.getLanguage()

    }
    getLanguage = () => {
        getMultiLang({
            domainName: 'hrzz',
            moduleId: 'hrzzmb',
            other:true,
            callback: (json, status, init) => {
                Toast.hide()
                this.setState({
                    json: json,
                },()=>{
                    let personalInfo=sessionStorage.getItem('personalInfo')
                  console.log(personalInfo)
                  this.updateMenu(true,false)
                    if (!personalInfo) {
                        this.loginInfo()
                    } else {
                        let isAppr = sessionStorage.getItem('isAppr')
                        let ESS_NON418 = sessionStorage.getItem('ESS_NON418')
                        let showGroup = sessionStorage.getItem('showGroup')
                        console.log(showGroup)
                        let userid = JSON.parse(personalInfo).pkpsndoc
                        if (showGroup) {
                            this.setState({showGroup: showGroup === 'true' ? true : false})
                        }
                        // else {
                        //     console.log(userid)
                        //     this.CheckPermissionByUser(userid)
                        // }
                        if(!isAppr){
                            this.loginInfo()
                        }else if(isAppr=='true'){
                            this.updateMenu(true,ESS_NON418)
                        }else {
                            this.updateMenu(false,ESS_NON418)
                        }
                    }
                })
            }
        })
    }
  //是否有团队管理节点的权限
  CheckPermissionByUser = (userid) => {
    let params = {
      userid: userid
    }
    ajaxhr({
      url: url.CheckPermissionByUser,
      noNeedShowError: false,
      data: params,
      success: (result) => {
        console.log(result)
        if (result.retCode === 0 && result.data.isShow === 'Y') {
          sessionStorage.setItem('showGroup', 'true')
          this.setState({ showGroup: true })
        } else {
          sessionStorage.setItem('showGroup', 'false')
          this.setState({ showGroup: false })
        }
        // sessionStorage.setItem('isAppr', isAppr)

      },
      error: (err) => {
        console.log(err)//俺也不懂是不是这个报错格式，但是之前的都是这样写的，先复制过来吧
        if (err.data && err.data.retCode == -1) {
          err.message = err.data.retMsg
        }
        errHandle(err, json)
      }
    })
  }
    // 是否拥有查看审批中心权限 以及个人信息
    loginInfo=()=>{
        let {json}=this.state
        this.setState({visable:true})
        ajaxhr({
            url: url.loginInfo,
            noNeedShowError: false,
            success: (result) => {
              console.log(result)
                let data=result.data
                if(data){
                    let isAppr=data.isAppr
                    let cuserid=data.cuserid
                    let isSF_Role=data.isSF_Role
                    let ESS_NON418=data.ESS_NON418
                    let personalInfo=data.personalInfo
                    if(personalInfo){
                        sessionStorage.setItem('personalInfo',JSON.stringify(personalInfo))
                      let showGroup = sessionStorage.getItem('showGroup')
                      console.log(showGroup)
                      let userid = personalInfo.pkpsndoc
                      if (showGroup) {
                        this.setState({ showGroup: showGroup === 'true' ? true : false })
                      } else {
                        this.CheckPermissionByUser(userid)
                      }
                      // let userid = JSON.parse(personalInfo).pkpsndoc
                      // console.log(userid)
                      // this.CheckPermissionByUser(userid)
                        // 打日志测试
                        let personalInfotest=sessionStorage.getItem('personalInfo')
                        let log4='首页存sessionStorage之后，再取sessionStorage中的personalInfo=====》'+personalInfotest+'    头部标识=====》'+sessionStorage.getItem('showNav')
                        ajaxhr({
                            url: url.setlog,
                            noNeedShowError: false,
                            data: {log:log4},
                            success: (result) => {
                            },
                            error: (err) =>{
                                if (isAuthExpiredResponse(err)) {
                                    errHandle(err,json)
                                }
                            }
                        })
                    }
                    sessionStorage.setItem('cuserid',cuserid)
                    sessionStorage.setItem('isAppr',isAppr)
                    sessionStorage.setItem('isSF_Role',isSF_Role)
                    sessionStorage.setItem('ESS_NON418',ESS_NON418)

                    if(isSF_Role.toString()==='false'){
                        //退出应用
                        Modal.alert(json["hrzzmb-000002"], '當前用戶沒有權限進入該應用', [{
                            text: json["hrzzmb-000003"],//取消
                            onPress: () =>kk.app.exit()
                        }])
                        // alert('當前用戶沒有權限進入該應用')
                        // kk.app.exit()
                    }

                    this.updateMenu(isAppr,ESS_NON418.toString())
                }
            },
            error: (err) =>{
              console.log(err)
                this.setState({visable:false})
                if (isAuthExpiredResponse(err) || (err && err.data && err.data.retCode==-1)) {
                    if (err && err.data && err.data.retCode==-1) {
                        err.message=err.data.retMsg
                    }
                    errHandle(err,json)
                }
            }
        })
    }
    // 修改菜单配置
    updateMenu=(isAppr,ESS_NON418)=>{
        if(ESS_NON418==='true'){//418员工
            RouterPageBy418.forEach((item)=>{
                if(item.auth === 'Y'){
                    item.visable=isAppr
                }
            });
            this.setState({RouterPageMenu:RouterPageBy418,visable:false})
        }else {
            RouterPage.forEach((item)=>{
                if(item.auth === 'Y'){
                    item.visable=isAppr
                }
            });
            this.setState({RouterPageMenu:RouterPage,visable:false})
        }

    }
    // getPsnDoc = () => {
    //     this.setState({visable:true})
    //     const areaCode = 'bd_psndoc';
    //     proFetchNew({
    //         url: url.PsninfoQueryAction,
    //         data: {
    //             areaCode,
    //             pk_psndoc: this.urlParam.pk_psndoc,
    //             psntype: this.urlParam.psntype
    //         },
    //         info: {appcode},
    //         loading: true,
    //         noNeedShowError: false
    //       }).then((result) => {
    //         console.log(result)
    //             if (result.success) {
    //                 if (result.data[areaCode]&&result.data[areaCode][areaCode]&&result.data[areaCode][areaCode].rows.length) {
    //                     // let data=result.data[areaCode][areaCode].rows[0].values
    //                     // let userCode=data.code.value
    //                     // let pk_psndoc=data.pk_psndoc.value
    //                     // sessionStorage.setItem('userCode',userCode)
    //                     // sessionStorage.setItem('pk_psndoc',pk_psndoc)
    //                     // sessionStorage.setItem('personalInfo',JSON.stringify(data))
    //                     // this.getIsApprover(pk_psndoc)
    //                     // this.setState({imfodata:data,visable:false},()=>{
    //                     //     console.log(sessionStorage.getItem('pk_psndoc'))
    //                     // })
    //                 }
    //             }
    //         });
    // };

    // getPsnDoc = () => {
    //     let json=this.state.json
    //     Toast.loading(json["hrzzmb-000001"],0)
    //     ajax({
    //         url: '/nccloud/platform/appregister/querypersonsettings.do',
    //         info: {
    //             appcode: '60652010'
    //         },
    //         data: {
    //             rqCode: "querypersonsettings"
    //         },
    //         success: ( res ) => {
    //             Toast.hide();
    //             console.log(res.data)
    //             this.setState({imfodata:res.data},()=>{
    //                 let imfodata=this.state.imfodata
    //                 let userCode=imfodata.userCode?imfodata.userCode:''
    //                 sessionStorage.setItem('userCode',userCode)
    //             })
    //         },
    //         error: ( err )=>{
    //             console.log(err)
    //             Toast.hide();
    //             let val = err.message||err.data.error.message
    //             Toast.fail(val, 2);
    //         }
    //     })
    // };
    // getPhoto = () => {
    //     proFetch({
    //         url: '/nccloud/hrzz/psninfo/PsninfoPhotoQueryAction.do',
    //         data: {
    //             areaCode: 'bd_psndoc',
    //             pk_psndoc: this.urlParam.pk_psndoc,
    //             psntype: this.urlParam.psntype
    //         },
    //         info: {appcode},
    //         loading: true,
    //         noNeedShowError: true,
    //     })
    //         .then((result) => {
    //             if (result.success) {
    //                 this.setState({image:result.data?result.data.image:""})
    //             }
    //         })
    // };
    // 关闭页面的方法
    closePage () {
        NativeObj.closePage()
    }
    // 打开其他页面的方法
    openPage (data) {
        if (data.code === 'quitquestionnaire') {
            console.log('quitquestionnaire')
            this.openWindow()
        } else {
            hrRouter.push(data.url)
        }


    }
    // 打开新的window
    openWindow () {
        console.log('openWindow')
        NativeObj.getAppCode((data) => {
            console.log('code', data, typeof data);
            let appCode = JSON.parse(data).data.code;
            let url = 'https://ys.diwork.com/approve-app/esn/nptdyo4p/c6a3cd9c3c3541c0a03160ebf7934038?upesntype=urlWithUserCode&usercode=' + appCode
            NativeObj.openWindow(url)
        });
    }
    render() {
      let { visable, RouterPageMenu, showGroup ,json} = this.state
      const currentRouterPageNames = getRouterPageNames()
        let contentDom = RouterPageMenu.map(item => {
            if(item.code==='leaveoffQuery') {
              return (
                <div class="view-list" style={{display:item.visable?'':"none"}} onClick={this.openPage.bind(this, item)}>
                    <div class="view-local-list">
                      <div class="local-image-content">
                        <img class="local-image" src={businessLogo} alc="businessLogo"></img>
                      </div>
                      <p class='view-list-title'>{getRouterPageName(item, currentRouterPageNames)}</p>
                    </div>
                </div>
              )
            } else {
              return (
                <div class="view-list" style={{display:item.visable?'':"none"}} onClick={this.openPage.bind(this, item)}>
                    <i class={`iconfont hrfont ${item.icon} ${item.color}`}></i>
                    <p class='view-list-title'>{getRouterPageName(item, currentRouterPageNames)}</p>
                </div>
              )
            }
        })

      let contentDomGroup = RouterPageGroup.map(item => {
        let imgSrc = ''
        switch(item.code) {
          case 'clockIn':
            return (
              <div class="view-list" style={{display:item.visable?'':"none"}} onClick={this.openPage.bind(this, item)}>
                <div class="view-local-list">
                  <div class="local-image-content">
                    <img class="local-image" src={clockIn} alc="businessLogo"></img>
                  </div>
                  <p class='view-list-title'>{item.name}</p>
                </div>
              </div>
            )
            break;
          case 'businesstrip':
            return (
              <div class="view-list" style={{display:item.visable?'':"none"}} onClick={this.openPage.bind(this, item)}>
                <div class="view-local-list">
                  <div class="local-image-content">
                    <img class="local-image" src={businesstrip} alc="businessLogo"></img>
                  </div>
                  <p class='view-list-title'>{item.name}</p>
                </div>
              </div>
            )
            break;
        }
      })

        return (
                <div class="main homepage" >
                    <div className="main_headernew"></div>
                    <Spin spinning={visable} size='large' style={{minHeight:'380px'}}>
                    {/* <div className="main_header">
                        <i class={`iconfont hrfont hr-sousuo $`}></i>
                    </div>
                    <div className="info">
                        <div className="img">
                            <img src={image?image:img} />
                        </div>
                        <div style={{marginLeft:"10px"}}>
                            <div className="text"><span>{imfodata.name?imfodata.name.value:""}</span></div>
                            <div className="text"><span>{imfodata.pk_group?imfodata.pk_group.display:""}</span></div>

                        </div>
                    </div> */}
              <div className='titlearea'>{json['obu-000026']}</div>
              <div class="view-group">
                {
                  contentDom
                }
              </div>
              {/* 因为找不到有权限的账号，所以加了个!，正常要去掉 */}
              {/* {<span>
                <div className='titlearea'>团队业务</div>
              <div class="view-group">
                {
                  contentDomGroup
                }
              </div>
              </span>} */}

                    </Spin>
             </div>


        );
    }
}

thirdLog(() => {
    ReactDOM.render(<Homepage/>, document.getElementById('app'));
});
